/**
 * getFactDetail接口的Mock数据
 * 基于API文档和dataPanel.vue中的使用逻辑生成
 */

// 销售事实表的详情数据
export const mockSalesFactDetail = {
  code: 200,
  message: 'success',
  data: {
    dimInfos: [
      // 时间维度
      {
        unitCode: 'time_year',
        unitName: '年份',
        belongDimName: null
      },
      {
        unitCode: 'time_month',
        unitName: '月份',
        belongDimName: null
      },
      {
        unitCode: 'time_quarter',
        unitName: '季度',
        belongDimName: null
      },
      {
        unitCode: 'time_date',
        unitName: '日期',
        belongDimName: null
      },
      // 地理维度
      {
        unitCode: 'geo_region',
        unitName: '地区',
        belongDimName: null
      },
      {
        unitCode: 'geo_city',
        unitName: '城市',
        belongDimName: null
      },
      {
        unitCode: 'geo_province',
        unitName: '省份',
        belongDimName: null
      },
      // 产品维度
      {
        unitCode: 'prod_category',
        unitName: '产品类别',
        belongDimName: null
      },
      {
        unitCode: 'prod_brand',
        unitName: '品牌',
        belongDimName: null
      },
      {
        unitCode: 'prod_name',
        unitName: '产品名称',
        belongDimName: null
      },
      // 客户维度
      {
        unitCode: 'cust_segment',
        unitName: '客户细分',
        belongDimName: null
      },
      {
        unitCode: 'cust_type',
        unitName: '客户类型',
        belongDimName: null
      },
      // 退化维度（belongDimName为null）
      {
        unitCode: 'order_id',
        unitName: '订单ID',
        belongDimName: null
      },
      {
        unitCode: 'customer_id',
        unitName: '客户ID',
        belongDimName: null
      },
      {
        unitCode: 'product_id',
        unitName: '产品ID',
        belongDimName: null
      }
    ],
    measureInfos: [
      {
        unitCode: 'sales_amount',
        unitName: '销售金额',
        belongDimName: null
      },
      {
        unitCode: 'sales_quantity',
        unitName: '销售数量',
        belongDimName: null
      },
      {
        unitCode: 'profit_amount',
        unitName: '利润金额',
        belongDimName: null
      },
      {
        unitCode: 'discount_amount',
        unitName: '折扣金额',
        belongDimName: null
      },
      {
        unitCode: 'order_count',
        unitName: '订单数量',
        belongDimName: null
      },
      {
        unitCode: 'customer_count',
        unitName: '客户数量',
        belongDimName: null
      }
    ]
  }
}

// 订单事实表的详情数据
export const mockOrderFactDetail = {
  code: 200,
  message: 'success',
  data: {
    dimInfos: [
      // 时间维度
      {
        unitCode: 'order_date',
        unitName: '订单日期',
        belongDimName: null
      },
      {
        unitCode: 'delivery_date',
        unitName: '交付日期',
        belongDimName: null
      },
      // 订单维度
      {
        unitCode: 'order_status',
        unitName: '订单状态',
        belongDimName: null
      },
      {
        unitCode: 'order_type',
        unitName: '订单类型',
        belongDimName: null
      },
      {
        unitCode: 'payment_method',
        unitName: '支付方式',
        belongDimName: null
      },
      // 客户维度
      {
        unitCode: 'customer_level',
        unitName: '客户等级',
        belongDimName: null
      },
      {
        unitCode: 'customer_source',
        unitName: '客户来源',
        belongDimName: null
      },
      // 退化维度
      {
        unitCode: 'order_no',
        unitName: '订单号',
        belongDimName: null
      },
      {
        unitCode: 'customer_id',
        unitName: '客户ID',
        belongDimName: null
      }
    ],
    measureInfos: [
      {
        unitCode: 'order_amount',
        unitName: '订单金额',
        belongDimName: null
      },
      {
        unitCode: 'order_quantity',
        unitName: '订单数量',
        belongDimName: null
      },
      {
        unitCode: 'shipping_cost',
        unitName: '运费',
        belongDimName: null
      },
      {
        unitCode: 'tax_amount',
        unitName: '税费',
        belongDimName: null
      }
    ]
  }
}

// 用户行为事实表的详情数据
export const mockUserBehaviorFactDetail = {
  code: 200,
  message: 'success',
  data: {
    dimInfos: [
      // 时间维度
      {
        unitCode: 'behavior_date',
        unitName: '行为日期',
        belongDimName: null
      },
      {
        unitCode: 'behavior_hour',
        unitName: '行为小时',
        belongDimName: null
      },
      // 行为维度
      {
        unitCode: 'behavior_type',
        unitName: '行为类型',
        belongDimName: null
      },
      {
        unitCode: 'page_type',
        unitName: '页面类型',
        belongDimName: null
      },
      {
        unitCode: 'device_type',
        unitName: '设备类型',
        belongDimName: null
      },
      // 用户维度
      {
        unitCode: 'user_segment',
        unitName: '用户细分',
        belongDimName: null
      },
      {
        unitCode: 'user_level',
        unitName: '用户等级',
        belongDimName: null
      },
      // 退化维度
      {
        unitCode: 'user_id',
        unitName: '用户ID',
        belongDimName: null
      },
      {
        unitCode: 'session_id',
        unitName: '会话ID',
        belongDimName: null
      }
    ],
    measureInfos: [
      {
        unitCode: 'page_views',
        unitName: '页面浏览量',
        belongDimName: null
      },
      {
        unitCode: 'click_count',
        unitName: '点击次数',
        belongDimName: null
      },
      {
        unitCode: 'duration',
        unitName: '停留时长',
        belongDimName: null
      },
      {
        unitCode: 'bounce_rate',
        unitName: '跳出率',
        belongDimName: null
      }
    ]
  }
}

/**
 * 根据factId返回对应的Mock数据
 */
export const getMockFactDetail = (factId) => {
  const mockDataMap = {
    'SALES_FACT': mockSalesFactDetail,
    'ORDER_FACT': mockOrderFactDetail,
    'USER_BEHAVIOR_FACT': mockUserBehaviorFactDetail
  }
  
  return mockDataMap[factId] || mockSalesFactDetail
}

/**
 * 模拟getFactDetail接口调用
 * 可以直接替换原有的接口调用
 */
export const mockGetFactDetail = async (params = {}, options = {}) => {
  // 模拟网络延迟
  await new Promise(resolve => setTimeout(resolve, 500))
  
  const { wid: factId } = params
  const mockResponse = getMockFactDetail(factId)
  
  return {
    data: mockResponse.data
  }
}

/**
 * 在dataPanel.vue中使用的格式
 * 经过listTransfer转换后的数据结构
 */
export const getMockFactDetailMapped = (factId) => {
  const mockResponse = getMockFactDetail(factId)
  const { dimInfos, measureInfos } = mockResponse.data
  
  const listTransfer = (list) => {
    return list.map((v) => {
      return {
        ...v,
        id: v.unitCode,
        name: v.unitName,
      }
    })
  }
  
  return {
    dimensions: listTransfer(dimInfos),
    measures: listTransfer(measureInfos)
  }
}
